
import React, { useEffect } from 'react';
import { Container, Box, Card, CardContent, Typography, Button, Grid, Avatar, LinearProgress, CircularProgress } from '@mui/material';
import Environment from '@web-client/services/environment';
import { auth } from '@web-client/firebase';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@web-client/state/store';
import {
  getCreatorSubscription,
  subscribeToCreator,
  selectors as subscriptionSelectors,
  unsubscribeFromCreator,
} from '@web-client/state/slices/subscriptions';
import { PaymentMethodSettings } from '../account/Wallet';



const SubscribeTo: React.FC = () => {

  // Make a query to grab the current user's wallet information as far
  // as the current user's preconfigured payment cards
  const { creatorId } = useParams<{ creatorId: string }>();

  const dispatch = useAppDispatch();
  const subscriptionInfo =
    useAppSelector(subscriptionSelectors.subscriptionInfo);
  const isGettingSubscriptionInfo =
    useAppSelector(subscriptionSelectors.isGettingSubscriptionInfo);

  const currentSubscriptionInfo = subscriptionInfo[creatorId || ''] || null;

  const isAlreadySubscribed = currentSubscriptionInfo?.isSubscribed || false;

  const isSubscribing = useAppSelector(subscriptionSelectors.isSubscribing);
  const isUnsubscribing = useAppSelector(subscriptionSelectors.isUnsubscribing);


  useEffect(() => {
    if (creatorId) {
      dispatch(getCreatorSubscription(creatorId));
    }
  }, [creatorId, dispatch]);

  const creatorProfile = currentSubscriptionInfo?.targetCreatorProfile || null;

  const creator = {
    name: creatorProfile?.displayName ?? 'Creator Name',
    email: creatorProfile?.email ?? 'Creator Email',
  };

  const subscriptionCost = currentSubscriptionInfo?.pricingSettings?.monthlySubscriptionPrice ?? 9999.99;
  const subscriptionCurrency = currentSubscriptionInfo?.pricingSettings?.monthlySubscriptionCurrency ?? 'USD';
  const subscriptionDescription = 'Monthly subscription for exclusive access to premium content.';

  const hasDefaultPaymentMethod = currentSubscriptionInfo?.hasDefaultPaymentMethod;


  // Who is the current user?

  // Who is the creator?



  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      {isGettingSubscriptionInfo && <LinearProgress />}
      <Card>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            Support {creator.name}
          </Typography>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12}>
              {/* <Typography variant="subtitle1">
                <strong>Name:</strong> {creator.name}
              </Typography> */}
              {/* <Typography variant="body2">
                <strong>Email:</strong> {creator.email}
              </Typography> */}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                {creatorProfile?.bio || ''}
              </Typography>
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Avatar
            alt={creator.name}
            src={creatorProfile?.profilePictureUrl}
            sx={{ width: 56, height: 56 }}
            />
          </Box>

          <Box sx={{
            m: 2,
            visibility: isGettingSubscriptionInfo ? 'hidden' : 'visible',
          }} >
            <Typography variant="h6">
              Subscription Details
            </Typography>
            <Typography variant="body1">
              <strong>Cost:</strong> ${subscriptionCost.toFixed(2)} {subscriptionCurrency.toLocaleUpperCase()} / month
            </Typography>
            <Typography variant="body2">
              {subscriptionDescription}
            </Typography>
          </Box>

          {isAlreadySubscribed && (
            <Box sx={{ mb: 2 }}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="large"
                disabled={isSubscribing || isUnsubscribing}
                onClick={() => {
                  if (creatorId) {
                    dispatch(unsubscribeFromCreator(creatorId)).then(() => {
                      dispatch(getCreatorSubscription(creatorId));
                    });
                  }
                }}
              >
                {isUnsubscribing ? <CircularProgress /> : 'Unsubscribe'}
              </Button>
            </Box>
          )}


          <Box sx={{ mb: 2 }}>
          {!isAlreadySubscribed && !isGettingSubscriptionInfo && (
              <>

          {hasDefaultPaymentMethod ? (
             <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={isSubscribing || isUnsubscribing}
                size="large"
                    onClick={() => {
                      if (creatorId) {
                        dispatch(subscribeToCreator(creatorId)).then(() => {
                          dispatch(getCreatorSubscription(creatorId));
                        });
                      }
                }}
              >
                {isSubscribing ? <CircularProgress/> : 'Subscribe Now'}
              </Button>
                ) : (
            <>
              <Typography variant="body1" color="red">
                You do not have a default payment method set up. Please set one up to subscribe.
                      </Typography>
              {/* <Elements stripe={stripePromise}>
              <AddCard onCardAdded={() => console.log('yay')}/>
              </Elements> */}
              <PaymentMethodSettings onCardAdded={() => {
                if (creatorId) {
                  dispatch(getCreatorSubscription(creatorId || ''));
                }
              }}/>
            </>
          )}
            </>
          )}
          </Box>




        </CardContent>
      </Card>
    </Container>
  );
};

export default SubscribeTo;